import { phoneValidator, sfidValidator, emailValidator } from '@/comm/validator.js'

const formRules = {
  organ: [{ required: true, message: '请选择意向门店' }],
  organLabel: [{ required: true, message: '请选择意向门店' }],
  depart: [{ required: true, message: '请选择意向部门' }],
  departLabel: [{ required: true, message: '请选择意向部门' }],
  post: [{ required: true, message: '请选择意向岗位' }],
  postLabel: [{ required: true, message: '请选择意向岗位' }],
  name: [{ required: true, message: '请填写正确的姓名', pattern: /^[\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5]{2,6}([\u25CF\u00B7][\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5]{2,6})*$/ }],
  sfiddate: [{ required: true, message: '请选择身份证有效期的截至日期' }],
  nationLabel: [{ required: true, message: '请选择民族' }],
  political: [{ required: true, message: '请选择政治面貌' }],
  educationLabel: [{ required: true, message: '请选择最高学历' }],
  gender: [{ required: true, message: '请选择性别' }],
  married: [{ required: true, message: '请选择婚姻情况' }],
  education: [{ required: true, message: '请选择最高学历' }],
  educstart: [{ required: true, message: '请选择最高学历的开始时间' }],
  educend: [{ required: true, message: '请选择最高学历的结束时间' }],
  educschool: [{ required: true, message: '请填写最高学历毕业的院校' }],
  eductype: [{ required: true, message: '请选择最高学历学习方式' }],
  specname: [{ required: true, message: '请填写最高学历专业名称' }],
  spectype: [{ required: true, message: '请选择最高学历专业分类' }],
  spectypeLabel: [{ required: true, message: '请填写最高学历专业名称' }],
  phone: [{ validator: phoneValidator, message: '请输入正确的手机号' }],
  reghouse: [{ required: true, message: '请选择户口所在地' }],
  sfid: [{ validator: sfidValidator, message: '请输入正确的身份证号码' }],
  sfidaddr: [{ required: true, message: '请填写正确的身份证住址' }],
  workstatus: [{ required: true, message: '请选择与原单位劳动关系' }],
  personRelation: [{ required: true, message: '请选择是否有亲朋在西亚工作' }],
  salary: [{ required: true, message: '请填写待遇薪资', pattern: /^[0-9]*$/ }],
  age: [{ required: true, message: '请填写年龄', pattern: /^[0-9]*$/ }],
  recruitSource: [{ required: true, message: '请选择在何处得知招聘信息' }],
  isScadre: [{ required: true, message: '请选择是否曾任学生干部' }],
  scadrePost: [{ required: true, message: '请填写曾担任的学生干部职位' }],
  height: [{ required: true, message: '请填写身高,单位厘米' }],
  weight: [{ required: true, message: '请填写体重,单位公斤' }],
  email: [{ message: '请填写正确的电子邮件地址', validator: emailValidator }],
  no: [{ required: false }]
}

export default formRules
